import { WidgetSizeT } from "../../../localTypes/WidgetSizeT";

export const emaginWidgetSizes: WidgetSizeT[] = [
  {
    h: 1,
    w: 2,
  },
  {
    h: 2,
    w: 2,
  },
];
